"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.determinePageCount = exports.default = exports.Pager = void 0;
var React = _interopRequireWildcard(require("react"));
var _enums = require("./enums");
var _AlgoTypography = require("@algo/algo-styles/AlgoTypography");
var _icon = require("@algo/icon");
var _StyledPager = require("./StyledPager");
var _capsstrap = require("@algo/capsstrap");
var _StyledNavItem = _interopRequireDefault(require("./StyledNavItem"));
var _proRegularSvgIcons = require("@fortawesome/pro-regular-svg-icons");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
//libraries

//enums

//components

//styledComponents

var Pager = function Pager(props) {
  /**************************************************************************
      CALCULATED VALUES & BREVITY NAMES
   *************************************************************************/
  var offset = props.ellipsisOffset ? props.ellipsisOffset : 0;
  var threshold = props.ellipsisThreshold ? props.ellipsisThreshold : 20;
  var leftMin = Math.max(props.pageIndex - offset, 0);
  var rightMax = Math.min(props.pageIndex + offset, props.pageCount);
  var lastWasEllipsis = false;
  var determineItemText = function determineItemText(index) {
    var text = "";
    var callback;
    var type = _enums.EControlType.Item;
    if (props.pageCount <= threshold || index === 0 || index === props.pageIndex || index === props.pageCount - 1 || offset > 0 && (index >= leftMin && index <= props.pageIndex || index <= rightMax && index >= props.pageIndex)) {
      text = "".concat(index + 1);
      callback = function callback() {
        props.updatePageIndex(index);
      };
      type = _enums.EControlType.Item;
      lastWasEllipsis = false;
    } else {
      if (!lastWasEllipsis) {
        text = "...";
        callback = function callback() {};
        type = _enums.EControlType.Ellipsis;
        lastWasEllipsis = true;
      } else return null;
    }
    return /*#__PURE__*/React.createElement(_StyledNavItem.default, {
      active: props.pageIndex === index ? true : false,
      type: type ? type : _enums.EControlType.Item,
      size: props.size ? props.size : "md",
      backgroundColorActive: props.backgroundColorActive ? props.backgroundColorActive : "primary",
      backgroundColor: props.backgroundColor ? props.backgroundColor : "#fff",
      borderStyle: props.borderStyle,
      hoverBorderStyle: props.hoverBorderStyle,
      borderRadius: props.borderRadius,
      colorActive: props.colorActive ? props.colorActive : "#fff",
      color: props.color ? props.color : "#000",
      minimalNav: props.minimalNav ? true : false,
      onClick: callback,
      key: Math.random()
    }, /*#__PURE__*/React.createElement(_capsstrap.Center, null, /*#__PURE__*/React.createElement(_AlgoTypography.Body3, null, text)));
  };

  //Create the Buttons of the Pager
  var createNavItems = function createNavItems() {
    var navItems = []; // list to hold navigation buttons

    navItems.push( /*#__PURE__*/React.createElement(_StyledNavItem.default // add previous or 'left' button
    , {
      active: false,
      type: _enums.EControlType.Previous,
      size: props.size ? props.size : "md",
      backgroundColorActive: props.backgroundColorActive ? props.backgroundColorActive : "primary",
      backgroundColor: props.backgroundColor ? props.backgroundColor : "#fff",
      borderStyle: props.borderStyle,
      borderRadius: props.borderRadius,
      hoverBorderStyle: props.hoverBorderStyle,
      colorActive: props.colorActive ? props.colorActive : "#fff",
      color: props.color ? props.color : "#000",
      minimalNav: props.minimalNav ? true : false,
      onClick: function onClick() {
        back();
      },
      key: Math.random()
    }, /*#__PURE__*/React.createElement(_capsstrap.Center, null, /*#__PURE__*/React.createElement(_AlgoTypography.Body3, null, !props.minimalNav // check if User wants text or icon
    ? _enums.EControlType.Previous : /*#__PURE__*/React.createElement(_icon.Icon, {
      icon: _proRegularSvgIcons.faChevronLeft,
      size: "sm"
    })))));
    for (var i = 0; i < props.pageCount; i++) {
      // add all the page number buttons
      navItems.push(determineItemText(i));
    }
    navItems.push(
    /*#__PURE__*/
    // add next or 'right' button
    React.createElement(_StyledNavItem.default, {
      active: false,
      type: _enums.EControlType.Next,
      size: props.size ? props.size : "md",
      backgroundColorActive: props.backgroundColorActive ? props.backgroundColorActive : "primary",
      backgroundColor: props.backgroundColor ? props.backgroundColor : "#fff",
      borderStyle: props.borderStyle,
      hoverBorderStyle: props.hoverBorderStyle,
      borderRadius: props.borderRadius,
      colorActive: props.colorActive ? props.colorActive : "#fff",
      color: props.color ? props.color : "#000",
      minimalNav: props.minimalNav ? true : false,
      onClick: function onClick() {
        forward();
      },
      key: Math.random()
    }, /*#__PURE__*/React.createElement(_capsstrap.Center, null, /*#__PURE__*/React.createElement(_AlgoTypography.Body3, null, !props.minimalNav // check if user wants text or icon
    ? _enums.EControlType.Next : /*#__PURE__*/React.createElement(_icon.Icon, {
      icon: _proRegularSvgIcons.faChevronRight,
      size: "sm"
    })))));
    return navItems;
  };

  /**************************************************************************
      CALLBACKS & EVENT HANDLERS
   *************************************************************************/

  //function called by previous or 'left' button
  var back = function back() {
    if (props.pageIndex > 0) props.updatePageIndex(props.pageIndex - 1);
  };

  //function called by next or 'right' button
  var forward = function forward() {
    if (props.pageIndex < props.pageCount - 1) props.updatePageIndex(props.pageIndex + 1);
  };

  /**************************************************************************
      PRIMARY RENDER
   *************************************************************************/

  return /*#__PURE__*/React.createElement(_StyledPager.StyledPager, null, createNavItems());
};
exports.Pager = Pager;
var _default = Pager; // Used by external components to calculate the proper pageCount property to pass to Pager
exports.default = _default;
var determinePageCount = function determinePageCount(listLength, perPage) {
  return Math.floor(listLength / perPage) + (listLength % perPage > 0 ? 1 : 0);
};
exports.determinePageCount = determinePageCount;